export default function Footer() {
  const footerLinks = [
    {
      title: '热门分类',
      items: ['韩漫推荐', '日漫精选', '国漫热门', '完结漫画', '新作上架'],
    },
    {
      title: '阅读帮助',
      items: ['阅读指南', '常见问题', '反馈建议', '版权声明', '用户协议'],
    },
    {
      title: '关于我们',
      items: ['平台介绍', '更新日志', '联系我们', '加入我们'],
    },
  ];

  return (
    <footer id="footer" className="bg-secondary-100/60 border-t border-secondary-200/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="text-xl font-heading font-bold text-primary-600 cursor-pointer">
              亲亲漫画
            </a>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              亲亲漫画按地域精选韩漫、日漫、国漫热门推荐，海量免费漫画在线全集下拉式阅读，好看的漫画大全不间断更新，为漫画爱好者提供一站式免费阅读体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">{group.title}</h4>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-200/60 pt-8">
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">合作伙伴</h4>
            <p className="text-sm text-foreground-500">诚邀优质漫画平台与内容创作者加入合作</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 亲亲漫画 — 韩漫日漫国漫热门推荐 | 免费全集下拉式在线好看的漫画大全
            </p>
            <div className="flex items-center gap-4">
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">服务条款</a>
              <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}